// ======================================================================
// 📁 File: src/modules/service_crm/routes/ServiceCRMRoutes.js
// 📝 Purpose:
//   Route configuration for Service CRM module
//   - Dashboard
//   - Installed Products
// ======================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ServiceCRMLayout from "../ServiceCRMLayout";

// ======================================================================
// DASHBOARD
// ======================================================================
import ServiceCRMDashboard
from "../dashboard/pages/ServiceCRMDashboard";

// ======================================================================
// INSTALLED PRODUCTS
// ======================================================================
import InstalledProductListPage
from "../installed_products/pages/InstalledProductListPage";

import InstalledProductForm
from "../installed_products/pages/InstalledProductForm";

import InstalledProductDetailPage
from "../installed_products/pages/InstalledProductDetailPage";

import ServiceTicketListPage
from "../tickets/pages/ServiceTicketListPage";

import ServiceTicketForm
from "../tickets/pages/ServiceTicketForm";

import ServiceTicketDetailPage
from "../tickets/pages/ServiceTicketDetailPage";

// ======================================================================
// SATISFACTION
// ======================================================================

import SatisfactionListPage
from "../satisfaction/pages/SatisfactionListPage";

import ServiceTicketReportPage
from "../reports/pages/ServiceTicketReportPage";

import InstalledProductReportPage
from "../reports/pages/InstalledProductReportPage";

import SatisfactionAnalysisReportPage
from "../reports/pages/SatisfactionAnalysisReportPage";

import FeedbackReportPage
from "../reports/pages/FeedbackReportPage";

import FeedbackListPage
from "../feedback/pages/FeedbackListPage";

import ServiceVisitListPage
from "../visits/pages/ServiceVisitListPage";

import BusinessPartnerListPage
from "../../ppe/pages/masters/business_partner/BusinessPartnerListPage";

import UserBPMappingPage
from "../../pms/pages/UserBPMappingPage";

// ======================================================================
// ROUTES
// ======================================================================
export default function ServiceCRMRoutes() {

  return (

    <ServiceCRMLayout>

      <Routes>

        {/* ========================================================= */}
        {/* DEFAULT */}
        {/* ========================================================= */}
        <Route
          path="/"
          element={
            <Navigate
              to="dashboard"
              replace
            />
          }
        />

        {/* ========================================================= */}
        {/* DASHBOARD */}
        {/* ========================================================= */}
        <Route
          path="dashboard"
          element={
            <ServiceCRMDashboard />
          }
        />

        {/* ========================================================= */}
        {/* INSTALLED PRODUCTS LIST */}
        {/* ========================================================= */}
        <Route
          path="installed-products"
          element={
            <InstalledProductListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE INSTALLED PRODUCT */}
        {/* ========================================================= */}
        <Route
          path="installed-products/create"
          element={
            <InstalledProductForm />
          }
        />
        {/* ========================================================= */}
        {/* INSTALLED PRODUCT DETAIL */}
        {/* ========================================================= */}
        <Route
          path="installed-products/:id"
          element={
            <InstalledProductDetailPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT INSTALLED PRODUCT */}
        {/* ========================================================= */}
        <Route
          path="installed-products/:id/edit"
          element={
            <InstalledProductForm />
          }
        />

        {/* ========================================================= */}
        {/* SERVICE TICKETS LIST */}
        {/* ========================================================= */}
        <Route
          path="tickets"
          element={
            <ServiceTicketListPage />
          }
        />
        {/* ========================================================= */}
        {/* CREATE SERVICE TICKET */}
        {/* ========================================================= */}
        <Route
          path="tickets/create"
          element={
            <ServiceTicketForm />
          }
        />
        {/* ========================================================= */}
        {/* EDIT SERVICE TICKET */}
        {/* ========================================================= */}
        <Route
          path="tickets/:id/edit"
          element={
            <ServiceTicketForm />
          }
        />
        {/* ========================================================= */}
        {/* SERVICE TICKET DETAIL */}
        {/* ========================================================= */}
        <Route
          path="tickets/:id"
          element={
            <ServiceTicketDetailPage />
          }
        />
        {/* ========================================================= */}
        {/* CUSTOMER SATISFACTION */}
        {/* ========================================================= */}

        <Route
          path="satisfaction"
          element={
            <SatisfactionListPage />
          }
        /> 

        {/* ========================================================= */}
        {/* SERVICE TICKET REPORT */}
        {/* ========================================================= */}

        <Route
          path="reports/tickets"
          element={
            <ServiceTicketReportPage />
          }
        />
        <Route
          path="reports/installed-products"
          element={
            <InstalledProductReportPage />
          }
        />
        <Route
          path="reports/satisfaction"
          element={
            <SatisfactionAnalysisReportPage />
          }
        />

        <Route
          path="reports/feedback"
          element={
            <FeedbackReportPage />
          }
        />
        <Route
          path="feedback"
          element={
            <FeedbackListPage />
          }
        />

        <Route
          path="visits"
          element={
            <ServiceVisitListPage />
          }
        />
        <Route
          path="masters/business-partner"
          element={
            <BusinessPartnerListPage />
          }
        />
        <Route
          path="masters/business-partner-assignment"
          element={
            <UserBPMappingPage />
          }
        />
               

        {/* ========================================================= */}
        {/* FALLBACK */}
        {/* ========================================================= */}
        <Route
          path="*"
          element={
            <Navigate
              to="dashboard"
              replace
            />
          }
        />

      </Routes>

    </ServiceCRMLayout>
  );
}